// extracted by mini-css-extract-plugin
export var close = "modal-module--close--+v54W";
export var content = "modal-module--content--L3YIi";
export var header = "modal-module--header--OUafO";
export var modal = "modal-module--modal--ZRElS";
export var overlay = "modal-module--overlay--b8-q1";